import { useHistory } from 'react-router-dom';
import Parser from 'html-react-parser';
import { Pipette, Users } from 'lucide-react';
import l from '../../../lang';
import { Routes } from '../../../config/routes';
import TopDashboardSection from '../../common/top-dashboard-section';
import Card from '../../common/card';
import CardInfo from '../../common/card-info';
import Popup from '../../common/popup';
import AlertMessages from '../alert-messages';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info-unfilled.svg';
import { ReactComponent as CampaignsIcon } from '../../../assets/icons/marketing/campaigns.svg';
import './styles.scss';

interface MarketingOption {
  id: string;
  labelKey: string;
  descKey: string;
  tooltipKey: string;
  route: string;
  icon: React.ReactNode;
}

const MarketingHub = () => {
  const history = useHistory();

  const options: MarketingOption[] = [
    {
      id: 'checkout-themes',
      labelKey: 'menu.subItem.CHECKOUT_THEMES',
      descKey: 'marketing.checkoutThemes.desc',
      tooltipKey: 'marketing.checkoutThemes.tooltip',
      route: Routes.CHECKOUT_THEMES,
      icon: <Pipette className="marketing-hub__icon" strokeWidth={1.5} aria-hidden />,
    },
    {
      id: 'campaigns',
      labelKey: 'menu.subItem.MARKETING_CAMPAIGNS',
      descKey: 'marketing.campaigns.desc',
      tooltipKey: 'marketing.campaigns.tooltip',
      route: Routes.MARKETING_CAMPAIGNS,
      icon: <CampaignsIcon className="marketing-hub__icon" aria-hidden />,
    },
    {
      id: 'clients',
      labelKey: 'menu.subItem.CLIENTS',
      descKey: 'marketing.clients.desc',
      tooltipKey: 'marketing.clients.tooltip',
      route: Routes.CLIENTS,
      icon: <Users className="marketing-hub__icon" strokeWidth={1.5} aria-hidden />,
    },
  ];

  return (
    <div className="marketing-hub">
      <TopDashboardSection title={l('menu.item.SIDEBAR_MARKETING')} subtitle={l('marketing.subheadline')} />
      <AlertMessages />
      <Card className="marketing-hub__card">
        <div className="marketing-hub__grid" role="list">
          {options.map(option => (
            <CardInfo key={option.id} bottomElement={<div className="marketing-hub__accent-line" />}>
              <button
                type="button"
                className="marketing-hub__item"
                role="listitem"
                onClick={() => history.push(option.route)}
              >
                <div
                  className="marketing-hub__info"
                  onClick={e => e.stopPropagation()}
                  onKeyDown={e => e.stopPropagation()}
                >
                  <Popup
                    text={Parser(l(option.tooltipKey))}
                    icon={<InfoIcon className="marketing-hub__info-icon" aria-hidden />}
                  />
                </div>
                <div className="marketing-hub__icon-wrap">{option.icon}</div>
                <div className="marketing-hub__label">{l(option.labelKey)}</div>
                <div className="marketing-hub__desc">{l(option.descKey)}</div>
              </button>
            </CardInfo>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default MarketingHub;
